// services/connect.service.ts — Stripe Connect: onboard sub-contractors and pay
// them out. Pairs with the WebAPI ConnectController + ContractorPaymentsController.
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface ConnectStatus {
  onboarded: boolean;
  detailsSubmitted: boolean;
  payoutsEnabled: boolean;
  chargesEnabled: boolean;
}

export interface ConnectLink {
  url: string;
}

export interface ContractorPaymentRequest {
  contractorId: number;
  amount: number;
  projectId?: number;
  projectLaborCostId?: string;
  description?: string;
}

export interface ContractorPayment {
  id: number;
  contractorId: number;
  projectId?: number;
  amount: number;
  currency: string;
  stripeTransferId: string;
  status: string;
  description?: string;
  createdAt: string;
}

@Injectable({ providedIn: 'root' })
export class ConnectService {
  private connectUrl = environment.apiUrl + 'Connect/';
  private payUrl = environment.apiUrl + 'ContractorPayments';

  constructor(private http: HttpClient) {}

  getStatus(contractorId: number): Observable<ConnectStatus> {
    return this.http.get<ConnectStatus>(`${this.connectUrl}status/${contractorId}`);
  }

  createOnboardingLink(contractorId: number): Observable<ConnectLink> {
    return this.http.post<ConnectLink>(`${this.connectUrl}onboarding-link/${contractorId}`, {});
  }

  createDashboardLink(contractorId: number): Observable<ConnectLink> {
    return this.http.post<ConnectLink>(`${this.connectUrl}dashboard-link/${contractorId}`, {});
  }

  payContractor(req: ContractorPaymentRequest): Observable<ContractorPayment> {
    return this.http.post<ContractorPayment>(this.payUrl, req);
  }

  getContractorPayments(contractorId: number): Observable<ContractorPayment[]> {
    return this.http.get<ContractorPayment[]>(`${this.payUrl}/contractor/${contractorId}`);
  }

  getProjectPayments(projectId: number): Observable<ContractorPayment[]> {
    return this.http.get<ContractorPayment[]>(`${this.payUrl}/project/${projectId}`);
  }
}
